import {ClientScan} from '@/models/clientScans/ClientScanModel';
import EnvironmentService from '@/env/EnvironmentService';

const ClientScans: ClientScan[] = EnvironmentService.Environment.getAppDomainConfig()
  .clientScans.map(x => new ClientScan(x));

export default ClientScans;
